module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-hexagon-0834821f2b9cdecbb2a5f403dac9bd78.svg";